<template>
  <vs-tabs :value="0">
    <vs-tab label="사업장 등록" @click="onClickTab(0)">
      <div>
        <search-nav @handleSearch="handleSearch">
          <search-nav-item-field label="키워드" v-model="table.keyword" @keyupEvent="handleInput" />
        </search-nav>

        <div class="flex mb-4" style="justify-content: flex-end;">
          <vs-button
            class=""
            color="secondary"
            @click="onClickNew"
          > 신규작성
          </vs-button>
        </div>
        <vs-card >
          <vs-table
            stripe
            ref="table"
            :sst="true"
            :max-items="table.perPage"
            :data="table.list"
            :noDataText="$t('approval.결재문서가 없습니다')"
            @selected="handleItemClickDetail">

            <template slot="thead">
              <vs-th sort-key="id" style="min-width:130px;"><span class="w-full text-center">No.</span></vs-th>
              <vs-th sort-key="content$field_name" style="min-width:130px;"><span class="w-full text-center">사업장명</span></vs-th>
              <vs-th style="min-width:130px;"><span class="w-full text-center">주소</span></vs-th>
              <vs-th style="min-width:130px;"><span class="w-full text-center">사업기간</span></vs-th>
              <vs-th style="min-width:130px;"><span class="w-full text-center">계약금액</span></vs-th>

            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="text-center">{{ tr.id }}</vs-td>
                <vs-td class="text-center">{{ tr.field_name }}</vs-td>
                <vs-td class="text-center">{{ tr.address }}</vs-td>
                <vs-td class="text-center">{{ tr.work_begin_at }} ~ {{ tr.work_end_at }}</vs-td>
                <vs-td class="text-center">{{ tr.deposit_amount }}</vs-td>
              </vs-tr>

            </template>
          </vs-table>

          <div class="vs-con-table">
            <div class="con-pagination-table vs-table--pagination">
              <k-pagination
                :total="(lastPage) ? lastPage : 1"
                v-model="currentPage" @change="handleChangePage"></k-pagination>
            </div>
          </div>
        </vs-card>
      </div>
    </vs-tab>
    <!-- <vs-tab label="부서별 사업장 현황" @click="onClickTab(1)"></vs-tab> -->
  </vs-tabs>
</template>

<script>
import SearchNav from '@/components/nav/SearchNav'
import SearchNavItemProject from '@/components/nav/SearchNavItemProject'
import KPagination from '@/components/kPagination/kPagination'
import SearchNavItemKeyword from '@/components/nav/SearchNavItemKeyword'
import SearchNavItemField from '@/components/nav/SearchNavItemField'
export default {
  name: 'FieldList',
  components: {
    SearchNavItemField,
    SearchNavItemKeyword,
    KPagination,
    SearchNavItemProject,
    SearchNav},
  data () {
    return {
      // 검색 네비게이션
      nav: {
        projectId:'',
        date: ['', ''],
        keyword: '',
        type: '',
        typeList: [],
        orderTarget:'created_at',
        orderDirection:'desc',
        searchTypes: [
          {text:'제목', value:'content$title'},
          {text:'작성자', value:'content$writer'},
        ],
        searchType: 'content$title',
      },

      currentPage: 1,
      lastPage: 1,
      total: 0,
      table: {
        list: [],
        perPage: 20,
        keyword: ''
      }
    }
  },
  created () {
    this.initBreadcrumb()
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    }
  },
  mounted () {
    this.loadFieldList()
  },
  methods: {
    initBreadcrumb () {
      if (parseInt(this.projectId) === 2) {
        this.$store.commit('menu/UPDATE_PAGE_LIST', [
          {title: 'Home'}, {title: '사업장/시설물 개요'}, {
            title: '직영사업장',
            active: true
          }
        ])
      } else {
        this.$store.commit('menu/UPDATE_PAGE_LIST', [
          {title: 'Home'}, {title: '사업장/시설물 개요'}, {
            title: '직영사업장',
            active: true
          }
        ])
      }
    },
    async loadFieldList () {
      const projectId = this.projectId
      const page = this.currentPage
      const perPage = this.table.perPage
      const keyword = this.table.keyword

      await this.$store.dispatch('project/LOAD_FIELD_LIST', {projectId, type:'사업장(직접수행)', keyword, page, perPage})
      const fieldListInfo = this.$store.state.project.fieldListInfo
      this.table.list = fieldListInfo.data

      this.currentPage = fieldListInfo.current_page
      this.lastPage = fieldListInfo.last_page
      this.total = fieldListInfo.total

    },
    onClickTab (tabIndex) {
      if (tabIndex === 0) {
        this.$router.push({ name: 'field-workplace-list' })
      } else if (tabIndex === 1) {
        this.$router.push({ name: 'field-workplace-info' })
      }
    },
    onClickSearch () {
      this.loadList()
    },
    onClickSort (sortKey, asc) {
      this.sortKey = sortKey
      this.asc = asc
    },
    onChangePage (page) {
      this.page = page
    },
    onClickDownload () {
      this.popup.excel = true
    },
    onClickNew () {
      this.$router.push({ name: 'field-workplace-create' })
    },
    onClickClose () {
      const keys = Object.keys(this.popup)
      keys.map(key => {
        this.popup[key] = false
      })
    },
    onClickDetail (value, target) {
    },

    handleItemClickDetail (data) {
      this.$router.push({name: 'field-workplace-update', params: { proj_id: this.$route.params.proj_id, postId: data.id }})
    },

    handleChangePage (page) {
      this.currentPage = page
      this.loadFieldList()
    },
    // 사업장 검색 폼에서 Enter 키가 눌렸을 때
    handleInput(data) {
      this.table.keyword = data;
      this.handleSearch();
    },
    // "검색" 버튼이 클릭됐을 때
    handleSearch() {
      this.loadFieldList();
    }
  }
}
</script>

<style scoped>

</style>
